import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { theme } from '@/helpers/Environment';
import { toKebabCase } from '@/helpers/StringHelpers';
import { isWalletPayment } from '@/checkout/helpers/wallets';
import store from '@/store/store';
@Component({ name: 'PayButton' })
export default class PayButton extends Vue {
    usePaymentRequestButton = false;
    // TODO Make this dynamic based on tenant and/or cart contents?
    brandedType = 'buy';
    t;
    @Prop({ default: 'default' })
    context;
    @Prop({ default: 0 })
    paymentDueByCreditCard;
    @Prop({ default: false })
    disabled;
    @Prop({ default: false })
    processing;
    @Prop()
    supportedWallet;
    @Prop()
    selectedPaymentType;
    @Prop({ default: false })
    isMobile;
    @Prop()
    wallet;
    mounted() {
        this.initializeWallet();
    }
    loading = false;
    @Watch('supportedWallet')
    initializeWallet() {
        if (this.wallet) {
            this.loading = true;
            // this.wallet could be unreachable in race conditions, maybe if `this` has been destroyed?
            const wallet = this.wallet;
            wallet.enabled
                .then((value) => {
                if (value != 'none') {
                    this.usePaymentRequestButton = true;
                    const button = wallet.paymentRequestButton(this.brandedTheme, this.brandedType);
                    button.mount(this.$refs.brandedWrapper);
                    button.on('click', (e) => {
                        e.preventDefault();
                        this.$emit('click');
                    });
                }
            })
                .finally(() => {
                this.loading = false;
            });
        }
    }
    get usingWallet() {
        // Cannot use wallets for free carts.
        return isWalletPayment(this.selectedPaymentType) && this.paymentDueByCreditCard > 0;
    }
    get usingInternal() {
        // Use internal pay button when disabled. Google Pay's button can not be disabled.
        return !this.usingWallet || this.disabled || !this.usePaymentRequestButton;
    }
    get wrapperClass() {
        if (this.usingWallet) {
            const brand = toKebabCase(this.supportedWallet);
            return `wallet-${brand}`;
        }
        else {
            return '';
        }
    }
    get classNames() {
        return { 'branded-button': this.usingWallet };
    }
    get label() {
        const labels = this.isMobile ? this.t.mobile : this.t.desktop;
        if (this.context === 'checkout') {
            if (this.$store.state.Cart.redeemMembership) {
                return labels.completeRedeemMembershipLabel;
            }
            else if (store.getters['Cart/giftee']) {
                return labels.completeGiftButtonLabel;
            }
            else if (this.hasScheduledPayments) {
                return labels.makePayment;
            }
            else {
                return labels.completeButtonLabel;
            }
        }
        else {
            return labels.proceedButtonLabel;
        }
    }
    get brandedTheme() {
        return theme?.cartThemeMode || theme?.themeMode ? 'light' : 'dark';
    }
    get hasScheduledPayments() {
        return store.getters['Cart/hasScheduledPayments'];
    }
}
